export default __webpack_public_path__ + "static/media/photo--sm--alaina-1.413d08f0.jpg";